export const PAGE_TITLE = "Forgot Password";

export const PAGE_SUBTITLE = "Enter your email to reset your password.";

export const EMAIL_PLACEHOLDER = "Email";

export const SUBMIT_BUTTON_TEXT = "Send Email";

export const SUCCESS_MESSAGE = "Password reset email sent successfully!";

export const DEFAULT_ERROR_MESSAGE = "Something went wrong";
